import { buildMakeUseAxios } from "@root/api/api.tools";

export const axiosEnterprise = buildMakeUseAxios(import.meta.env.VITE_ENTERPRISE_SERVICE_URL);
